// routes.js
import Loader from 'Lib/utilities/Loader';

import apply from './apply';

const routes = [
	{
		path: '/',
		component: Loader(() => import('~/containers/dashboard/Index'))
	},
	{
		path: '/applications/:id([-a-f0-9]+)',
		component: Loader(() => import('~/containers/dashboard/View'))
	},
	{
		path: '/playground',
		component: Loader(() => import('Lib/containers/Playground'))
	},
	...apply
];

export default routes;
